export default {
  DOUBLE_CLICK_ON_TIMELINE: "interfaceUserActions:DOUBLE_CLICK_ON_TIMELINE",
  DROP_ON_TIMELINE: "interfaceUserActions:DROP_ON_TIMELINE",
  DRAG_IN_TIMELINE: "interfaceUserActions:DRAG_IN_TIMELINE",
  RESIZE_IN_TIMELINE: "interfaceUserActions:RESIZE_IN_TIMELINE",
  DROP_ON_NARRATIVE: "interfaceUserActions:DROP_ON_NARRATIVE",
  DRAG_IN_NARRATIVE: "interfaceUserActions:DRAG_IN_NARRATIVE",
  ADD_TO_NARRATIVE: "interfaceUserActions:ADD_TO_NARRATIVE",
  SET_START_DATE_INSPECTOR: "interfaceUserActions:SET_START_DATE_INSPECTOR",
  SET_NARRATIVE_INSPECTOR: "interfaceUserActions:SET_NARRATIVE_INSPECTOR",
  CREATE_RELATIONSHIP_INSPECTOR: "interfaceUserActions:CREATE_RELATIONSHIP_INSPECTOR",
  CREATE_RELATIONSHIP_IN_RELATIONSHIP: "interfaceUserActions:CREATE_RELATIONSHIP_IN_RELATIONSHIP",
  TOGGLE_SUBWAY_TRACK: "interfaceUserActions:TOGGLE_SUBWAY_TRACK",
  CREATE_RELATIVE_CONSTRAINT: "interfaceUserActions:CREATE_RELATIVE_CONSTRAINT",
  CREATE_DATE_CONSTRAINT: "interfaceUserActions:CREATE_DATE_CONSTRAINT",
  SWITCH_MOBILE_VIEW: "interfaceUserActions:SWITCH_MOBILE_VIEW"
};
